import {RootState} from '../rootReducer';
import {requestModelInputsList} from './api';

export const modelInputsSelector = (state: RootState) => state.modelInputs;
export const modelInputsListSelectorBuilder =
  (params: Parameters<typeof requestModelInputsList>) => (state: RootState) =>
    modelInputsSelector(state)[params[0]];
